// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--bfJK8","linksContainer":"_02712f2b3b--linksContainer--nnzAn","disclaimer":"_02712f2b3b--disclaimer--MrVSa","count":"_02712f2b3b--count--Ug9Tp"};